import React, { useEffect, useState } from "react"
import { Paper, TableCell, TableRow, Tooltip } from "@material-ui/core"
import {
  Title,
  TableCellDefault,
  DatatablesFooterServerSide,
  Loading,
  TableAction,
  MasterButton,
} from "App/Component/ui"

import { stableSort, getComparator } from "App/Component/ui/datatable/utils"
import {
  FormBookingAntrian,
  headCells,
  STYLE_MASTER_GUDANG_UTAMA,
  RESET_STATE_BOOKING_ANTRIAN,
  FormFilterBookingAntrian,
  RESET_STATE_FORM_FILTER,
  getByFilterBookingAntrian,
  KODE_ONSIDE,
  KODE_MOBILE,
  KODE_JKN,
} from "./ui"

import { useDatatables, useDatatablesServerSide } from "App/hooks"
import {
  defaultDateDisplay,
  defaultToastError,
  isNull,
  scrollToTop,
} from "App/utils/helpers"
import moment from "moment"
import { FreezeTable } from "components/organism"

export default function BookingAntrian() {
  const classes = STYLE_MASTER_GUDANG_UTAMA()

  const [rows, setRows] = useState([])
  const [formData, setFormData] = useState(RESET_STATE_BOOKING_ANTRIAN)
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER)
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    setLoading(true)
    const res = await getByFilterBookingAntrian(formFilter, pages, limit)
    if (res.state) {
      setRows(res.data)
      setTotalData(res.meta.count)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: setNewData })

  const handleClickUpdate = (row) => {
    // setStatusBookingSelected()
    setFormData({
      ...formData,
      id: row.id,
      rm_id: row.rm_id,
      label_rm: row.rm_id,
      name: row.name,
      nik: row.nik,

      insurance_no: row.insurance_no,
      insurance_name: row.insurance_name,

      company_id: row.company_id,
      company_name: row.company_name,

      schedule_doctor_id: `${row.schedule_doctor_id}--${row.doctor_schedule_day}`,
      norujukan: row.norujukan,
      nokontrol: row.nokontrol,

      remark: row.remark,
      initial: row.initial,
      antrianno: row.antrianno,

      date: moment(row.date).toDate(),
      doctor_name: row.doctor_name,
      doctor_id: row?.doctor_id,
      doctor_schedule_day: row.doctor_schedule_day,
      doctor_schedule_time_start: row.doctor_schedule_time_start,
      doctor_schedule_time_finish: row.doctor_schedule_time_finish,
      doctor_poliklinik_name: row.doctor_poliklinik_name,
      doctor_poliklinik_remark: row.doctor_poliklinik_remark,
      poli_name: row.doctor_poliklinik_name,

      asal: row?.mobileonsite,

      status_booking: row?.status_booking,
      status_rm: isNull(row?.status_rm) ? "kosong" : row?.status_rm,

      id_booking_form: row.id,
    })

    scrollToTop()
  }

  return (
    <div className={classes.root}>
      <Title title="Booking Antrian" />

      <FormBookingAntrian
        formData={formData}
        setFormData={setFormData}
        setRows={setRows}
        setNewData={setNewData}
      />

      <div className="mt-2">
        <Paper className={classes.paper}>
          <FormFilterBookingAntrian
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            withExportButton
            rows={rows}
            resetPagination={resetPagination}
          />
          <Loading show={loading} />
          <TableBookingAntrian
            rows={rows}
            handleClickUpdate={handleClickUpdate}
          />

          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </div>
  )
}

const TableBookingAntrian = ({ rows, handleClickUpdate }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  })

  const UserMobile = ({ mobileonsite }) => {
    if (parseInt(mobileonsite) === KODE_ONSIDE) {
      return "Onsite"
    } else if (parseInt(mobileonsite) === KODE_MOBILE) {
      return "Mobile"
    } else if (parseInt(mobileonsite) === KODE_JKN) {
      return "JKN"
    } else {
      return "Tidak Ditemukan"
    }
  }
  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow hover key={index}>
            <TableCell align="center">{index + 1}</TableCell>

            <TableCell align="center">
              <TableAction
                isDelete={false}
                clickUpdate={() => handleClickUpdate(row)}
              />
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">{row?.name}</TableCell>
            <TableCell align="left">{row?.rm_id}</TableCell>
            <TableCell align="left">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {isNull(row?.status_booking) ? (
                  "-"
                ) : row?.status_booking === true ? (
                  <MasterButton name="Aktif" color="lightgreen" type="button" />
                ) : (
                  <MasterButton
                    name="Dibatalkan"
                    color="danger"
                    type="button"
                  />
                )}
              </div>
            </TableCell>
            <TableCell align="left">
              {isNull(row?.isregistration) ? (
                "-"
              ) : row?.isregistration === true ? (
                <MasterButton
                  name="Sudah Registrasi"
                  color="lightgreen"
                  type="button"
                />
              ) : (
                <MasterButton
                  name="Belum Registrasi"
                  color="warning"
                  type="button"
                />
              )}
            </TableCell>
            <TableCell align="left">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {isNull(row.status_rm) ? (
                  <Tooltip
                    title="Harap lengkapi profil rekam medis terlebih dahulu"
                    aria-label="add"
                  >
                    <MasterButton
                      color="secondary"
                      name="Belum dimapping"
                      type="button"
                    />
                  </Tooltip>
                ) : row?.status_rm === true ? (
                  <MasterButton name="Aktif" color="lightgreen" type="button" />
                ) : (
                  <MasterButton name="Pending" color="warning" type="button" />
                )}
              </div>
            </TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.date, false)}
            </TableCell>
            <TableCell align="left">
              {row?.initial}
              {row?.antrianno}
            </TableCell>
            <TableCell align="left">{row?.nik}</TableCell>
            <TableCell align="left">
              {/* {isNull(row?.user_mobile_id) ? "Onsite" : "Mobile"} */}

              <UserMobile mobileonsite={row.mobileonsite} />
            </TableCell>
            <TableCell align="left">{row?.insurance_name}</TableCell>
            <TableCell align="left">{row?.mobile_phone}</TableCell>
            <TableCell align="left">
              {row?.phone_number_int}
              {row?.phone_number_ext}
            </TableCell>

            <TableCell align="left">{row?.doctor_name}</TableCell>
            <TableCell align="left">
              <div
                style={{
                  maxHeight: "30px",
                  overflow: "hidden",
                }}
              >
                {row?.remark}
              </div>
            </TableCell>

            <TableCellDefault row={row} />
          </TableRow>
        )
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  )
}
